import { TokenSymbol } from '@/domain/types/TokenSymbol'

import { Percentage } from '@/domain/types/NumericValues'
import approve from './actions/approve.svg?url'
import borrow from './actions/borrow.svg?url'
import deposit from './actions/deposit.svg?url'
import done from './actions/done.svg?url'
import exchange from './actions/exchange.svg?url'
import repay from './actions/repay.svg?url'
import withdraw from './actions/withdraw.svg?url'
import arrowRight from './arrow-right.svg?url'
import berriesPoints from './berries-points.png'
import boxArrowTopRight from './box-arrow-top-right.svg?url'
import cards from './cards.svg?url'
import circleInfo from './circle-info.svg?url'
import closeFilled from './close-filled.svg?url'
import down from './down.svg?url'
import downgrade from './downgrade.svg?url'
import equal from './equal.svg?url'
import eye from './eye.svg?url'
import giftbox from './giftbox.svg?url'
import greenArrowUp from './green-arrow-up.svg?url'
import harmonixPoints from './harmonix-points.png'
import hyperEvmLogo from './hyper-evm-logo.png'
import hyperSwap from './hyper-swap.svg?url'
import hypurrLogoText from './hypurr-logo-text.svg?url'
import hypurrLogo from './hypurr-logo.svg?url'
import hypurrPawNoShadow from './hypurr-paw-no-shadow.svg?url'
import hypurrPaw from './hypurr-paw.svg?url'
import hypurrLogoHorizontal from './hypurrfi-logo-horiz.svg?url'
import incentivizedBadge from './incentivized-badge.svg?url'
import isolated from './isolated.svg?url'
import kittenSwap from './kitten-swap.svg?url'
import kPoints from './kpoints.png'
import link from './link.svg?url'
import loopPoints from './loop-points.png'
import magicWandCircle from './magic-wand-circle.svg?url'
import magicWand from './magic-wand.svg?url'
import chart from './markets/chart.svg?url'
import inputOutput from './markets/input-output.svg?url'
import lock from './markets/lock.svg?url'
import output from './markets/output.svg?url'
import moreIconVertical from './more-icon-vertical.svg?url'
import moreIcon from './more-icon.svg?url'
import multiply from './multiply.svg?url'
import pyth from './oracle-providers/pyth.svg?url'
import redstone from './oracle-providers/redstone.svg?url'
import pause from './pause.svg?url'
import powder from './powder.png'
import rocket from './rocket.svg?url'
import seasonMewHero from './season-mew-hero.webp'
import sliderThumb from './slider-thumb.svg?url'
import snowflake from './snowflake.svg?url'
import spinUpDrops from './spinup-drops.png'
import success from './success.svg?url'
import theoPoints from './theo-points.png'
import threeDots from './three-dots.svg?url'
import timer from './timer.svg?url'
import transfer from './transfer.svg?url'
import up from './up.svg?url'
import upgrade from './upgrade.svg?url'
import valantisPoints from './valantis-points.jpg'
import coinbase from './wallet-icons/coinbase.svg?url'
import defaultWallet from './wallet-icons/default.svg?url'
import metamask from './wallet-icons/metamask.svg?url'
import walletConnect from './wallet-icons/wallet-connect.svg?url'
import wallet from './wallet.svg?url'
import warning from './warning.svg?url'
import waves from './waves.svg?url'

import { tokens } from './tokens'

export const assets = {
  cards,
  incentivizedBadge,
  hypurrPaw,
  hypurrPawNoShadow,
  hyperSwap,
  kittenSwap,
  isolated,
  transfer,
  hyperEvmLogo,
  hypurrLogo,
  hypurrLogoText,
  hypurrLogoHorizontal,
  sliderThumb,
  circleInfo,
  up,
  down,
  success,
  wallet,
  link,
  threeDots,
  arrowRight,
  warning,
  pause,
  snowflake,
  greenArrowUp,
  boxArrowTopRight,
  magicWand,
  magicWandCircle,
  moreIcon,
  moreIconVertical,
  eye,
  closeFilled,
  giftbox,
  rocket,
  downgrade,
  timer,
  multiply,
  equal,
  spinUpDrops,
  powder,
  loopPoints,
  waves,
  kPoints,
  theoPoints,
  harmonixPoints,
  seasonMewHero,
  valantisPoints,
  berriesPoints,
  walletIcons: {
    metamask,
    walletConnect,
    coinbase,
    default: defaultWallet,
  },
  markets: {
    chart,
    inputOutput,
    lock,
    output,
  },
  actions: {
    upgrade,
    downgrade,
    approve,
    done,
    borrow,
    deposit,
    withdraw,
    repay,
    exchange,
  },
  chain: {
    hyper: hyperEvmLogo,
    unknown: tokens.unknown,
  },
  token: tokens,
  oracleProviders: {
    redstone,
    pyth,
    hypurrfi: hypurrLogoText,
  },
}

export function getTokenColor(symbol: TokenSymbol, options?: { alpha?: Percentage; fallback?: string }): string {
  const color = tokenColors[symbol]
  const alpha = (options?.alpha ?? Percentage(1)).toFixed(2)
  const fallback = options?.fallback ?? `rgb(235 175 76 / ${alpha})`

  return color ? `rgb(${color} / ${alpha})` : fallback
}

const tokenColors: Record<TokenSymbol, `${number} ${number} ${number}`> = {
  [TokenSymbol('USDXL')]: '255 230 106',
  [TokenSymbol('sUSDe')]: '50 157 200',
  [TokenSymbol('USDC')]: '157 222 247',
  [TokenSymbol('HYPE')]: '157 217 175',
  [TokenSymbol('stTESTH')]: '157 217 175',
  [TokenSymbol('WHYPE')]: '161 252 231',
  [TokenSymbol('SolvBTC')]: '235 175 76',
  [TokenSymbol('wstHYPE')]: '106 197 176',
}
